import { Component } from "@angular/core";

@Component({
  selector: 'app-tax-additional',
  templateUrl: './tax.component.html',
  styleUrls: ['./tax.component.css',
    '../invoices.component.css'
  ]
})
export class TaxAdditional {
  searchTerm: string = '';

  headers = [
    { key: 'chargeType', label: 'Service Provider' },
    { key: 'documentType', label: 'Document Type' },
    { key: 'invoiceId', label: 'Document ID' },
    { key: 'invoiceDate', label: 'Invoice ID' },
    { key: 'totalUsd', label: 'Status' }
  ];

  invoices: { [key: string]: string }[] = [
    {
      chargeType: 'AWS',
      documentType: 'Tax Invoice',
      invoiceId: 'INV001',
      invoiceDate: '2025-04-01',
      totalUsd: '$150.00'
    },
    {
      chargeType: 'Azure',
      documentType: 'Statement',
      invoiceId: 'INV002',
      invoiceDate: '2025-04-05',
      totalUsd: '$220.00'
    },
    {
      chargeType: 'GCP',
      documentType: 'Receipt',
      invoiceId: 'INV003',
      invoiceDate: '2025-04-10',
      totalUsd: '$180.00'
    }
  ];
  

  sortBy(key: string) {
    this.invoices.sort((a, b) => {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    });
  }

  get filteredInvoices() {
    if (!this.searchTerm) return this.invoices;

    const term = this.searchTerm.toLowerCase();
    return this.invoices.filter(invoice =>
      this.headers.some(header =>
        String(invoice[header.key]).toLowerCase().includes(term)
      )
    );
  }
}
